module.exports = __webpack_public_path__ + "media/images/application/social_sharing/facebook-425beec482a0d2bef6afaa356e060840.png";